import { GtmEvents } from '@/gtm/gtm-events';

export class FooterGtmEvents extends GtmEvents {
  constructor() {
    super('СобытияВКорзине');
  }

  footerShown() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_ПоказБлока',
    });
  }

  deliveryLinkClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_Доставка',
    });
  }

  paymentLinkClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_Оплата',
    });
  }

  refoundChangeLinkClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_ОбменИВозврат',
    });
  }

  QALinkClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_ВопросыИОтветы',
    });
  }

  phoneNumberClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_Позвонить',
    });
  }

  logoClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_НаГлавную',
    });
  }

  mobileSectionClick(name, isMobile) {
    if (name.toLowerCase().includes('покупателям') && isMobile) {
      return this.gtmEvent({
        eventAction: 'КРЗ_Футер_Покупателям',
      });
    }
  }

  socialLinkClick(network) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Футер_Соцсети',
      eventLabel: network,
    });
  }
}

export const cartFooterGtmEvents = new FooterGtmEvents();
